import React, { Fragment, useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { FilterMatchMode } from "primereact/api";
import { Toast } from "primereact/toast";
import axios from "axios";
import { SERVICE_LOCATION, GET_USERS_API, GET_DEPOTS_API, UPDATE_USER_API } from "../constants/endpoints";
import { PASSWORD_NOT_MATCHING, FILL_PASSWORD_CHANGE_SECTION, ENTER_PASSWORD } from "./../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/fitter.css";

const Users = (props) => {
    const toast = useRef(null);

    const { data } = props;

    const [users, setUsers] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showUserModal, setShowUserModal] = useState(false);

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [position, setPosition] = useState("");
    const [userName, setUserName] = useState("");
    const [depots, setDepots] = useState(null);
    const [depot, setDepot] = useState(null);
    const [eco, setEco] = useState(false);
    const [newBuild, setNewBuild] = useState(false);
    const [maxAppWebAccess, setMaxAppWebAccess] = useState(true);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isFinanceTeam, setIsFinanceTeam] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [isAddUser, setIsAddUser] = useState(false);
    const [existingPassword, setExistingPassword] = useState("");

    const ukPhoneNumberRegex = /^(?:\+44|0)\d{10}$/;

    const [fullNameError, setFullNameError] = useState(false);
    const [mobileError, setMobileError] = useState(false);
    const [positionError, setPositionError] = useState(false);
    const [userNameError, setUserNameError] = useState(false);
    const [depotError, setDepotError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [passwordMismatchError, setPasswordMismatchError] = useState(false);

    useEffect(() => {
        getUsers();
        getDepots();
    }, [])

    const getUsers = async () => {
        const endPoint = SERVICE_LOCATION + GET_USERS_API;
        await axios.get(endPoint, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    setUsers(response.data.data.users);
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const getDepots = async () => {
        const endPoint = SERVICE_LOCATION + GET_DEPOTS_API;
        await axios.get(endPoint, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    setDepots(response.data.data.getDepots);
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }

            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const updateUser = () => {
        const endPoint = SERVICE_LOCATION + UPDATE_USER_API;
        const requestData = {
            "isAdd": isAddUser,
            "fullName": fullName.trim(),
            "email": email.trim(),
            "moblile": mobile,
            "position": position.trim(),
            "depotCode": depot.depotCode,
            "userName": userName.trim(),
            "password": (!isAddUser && password.trim() === "") ? existingPassword : password.trim(),
            "eco": eco ? "Y" : "N",
            "newBuild": newBuild ? "Y" : "N",
            "isFinanceTeam": isFinanceTeam ? "Y" : "N",
            "isActive": isActive ? "Y" : "N",
            "maxAppWebAccess": maxAppWebAccess ? "Y" : "N"
        }

        axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    setShowUserModal(false);
                    setUsers(response.data.data.users);
                    clearFields();
                    getUsers();
                    toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const handleAddUser = () => {
        setIsAddUser(true);
        setShowUserModal(true);
        setDefaultDepotForUser();
    }

    // Search functionality
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <div className="card flex">
                        <Button id="add-user" label="Add User" onClick={handleAddUser} />
                    </div>
                </div>
                <div className="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                    <div className="flex justify-content-end txt-right">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search functionality Ends here

    const setDefaultDepotForUser = () => {
        setDepot({ depotCode: data.data.userDetails.depotCode, depot: data.data.userDetails.depot });
    }

    const onRowSelect = (e) => {
        setIsAddUser(false);
        setShowUserModal(true);
        setFullName(e.data.fullName);
        setEmail(e.data.email);
        setMobile(e.data.mobile);
        setPosition(e.data.position);
        setUserName(e.data.userName);
        setDepot({ depotCode: e.data.depotCode, depot: e.data.depot });
        setIsFinanceTeam(e.data.isFinanceTeam === "Y" ? true : false);
        setIsActive(e.data.live === "Y" ? true : false);
        setEco(e.data.eco === "Y" ? true : false);
        setNewBuild(e.data.newBuild === "Y" ? true : false);
        setMaxAppWebAccess(e.data.maxAppWebAccess === "Y" ? true : false);
        setExistingPassword(e.data.password);
        setPassword("");
        setConfirmPassword("");
    }

    const clearFields = () => {
        setShowUserModal(false);
        setFullName("");
        setEmail("");
        setMobile("");
        setPosition("");
        setUserName("");
        setDepot(null);
        setIsFinanceTeam(false);
        setIsActive(true);
        setEco(false);
        setNewBuild(true);
        setMaxAppWebAccess(true);
        setFullNameError(false);
        setMobileError(false);
        setPositionError(false);
        setUserNameError(false);
        setDepotError(false);
        setPasswordError(false);
        setConfirmPasswordError(false);
        setPasswordMismatchError(false);
    }

    const onModalClose = () => {
        clearFields();
    }

    const handleUpdateUser = () => {
        const isValid = mobile.trim() === "" ? true : ukPhoneNumberRegex.test(mobile);
        fullName.trim() === "" ? setFullNameError(true) : setFullNameError(false);
        isValid ? setMobileError(false) : setMobileError(true);
        position.trim() === "" ? setPositionError(true) : setPositionError(false);
        userName.trim() === "" ? setUserNameError(true) : setUserNameError(false);
        isAddUser && password.trim() === "" ? setPasswordError(true) : setPasswordError(false);
        isAddUser && confirmPassword.trim() === "" ? setConfirmPasswordError(true) : setConfirmPasswordError(false);
        password !== confirmPassword ? setPasswordMismatchError(true) : setPasswordMismatchError(false);
        depot === null ? setDepotError(true) : setDepotError(false);

        if ((password === "" && confirmPassword !== "") || (password !== "" && confirmPassword === "")) {
            toast.current.show({ severity: "error", summary: "Error", detail: FILL_PASSWORD_CHANGE_SECTION, life: 5000 });
        }
        else if (password !== confirmPassword) {
            toast.current.show({ severity: "error", summary: "Error", detail: PASSWORD_NOT_MATCHING, life: 5000 });
        }
        else if (isAddUser && (password === "" || confirmPassword === "")) {
            toast.current.show({ severity: "error", summary: "Error", detail: ENTER_PASSWORD, life: 5000 });
        }
        else if (isAddUser && password.trim() !== "" && password !== confirmPassword) {
            toast.current.show({ severity: "error", summary: "Error", detail: PASSWORD_NOT_MATCHING, life: 3000 });
        }
        else if (fullName.trim() !== "" && position.trim() !== "" && userName.trim() !== "" && depot !== null && isValid) {
            updateUser();
        }
    }

    const footerContent = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={onModalClose} className="p-button-text" />
            <Button label={isAddUser ? "Add" : "Save"} icon="pi pi-check" onClick={handleUpdateUser} autoFocus />
        </div>
    );

    return (
        <Fragment>
            <Toast ref={toast} />
            <div className="worksheets-section">
                <h4>Users</h4>
                <DataTable className="font-12" value={users} datakey="userName" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                    selectionMode="single" selection={selectedUser} onSelectionChange={(e) => setSelectedUser(e.value)}
                    onRowSelect={onRowSelect} metaKeySelection={false}
                    filters={filters} header={header}
                    globalFilterFields={["userName", "fullName", "position", "mobile", "email", "depot", "depotCode",
                        "live", "maxAppWebAccess", "accessLevel", "eco", "newBuild", "password"]}
                    scrollable tableStyle={{ minWidth: "50rem" }}>
                    <Column field="userName" header="User Name"></Column>
                    <Column field="fullName" header="Full Name"></Column>
                    <Column field="position" header="Position"></Column>
                    <Column field="mobile" header="Mobile"></Column>
                    <Column field="email" header="Email"></Column>
                    <Column field="depot" header="Depot"></Column>
                    <Column field="depotCode" header="Depot Code" hidden></Column>
                    <Column field="live" header="IsActive"></Column>
                    <Column field="isFinanceTeam" header="IsFinanceTeam"></Column>
                    <Column field="maxAppWebAccess" header="MaxAppWebAccess"></Column>
                    <Column field="accessLevel" header="Access Level" hidden></Column>
                    <Column field="eco" header="Eco" hidden></Column>
                    <Column field="newBuild" header="NewBuild" hidden></Column>
                    <Column field="password" header="Password" hidden></Column>
                </DataTable>

                <Dialog header={isAddUser ? "Add User" : "Edit Details"} visible={showUserModal} style={{ width: "50vw" }}
                    onHide={onModalClose} footer={footerContent}>
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="firstName">Full Name</label>
                                <InputText value={fullName} id="firstName" onChange={(e) => setFullName(e.target.value)} className="p-inputtext-sm" />
                                {fullNameError && <small className="p-error">This field is required</small>}
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="email">Email</label>
                                <InputText value={email} id="email" onChange={(e) => setEmail(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="mobile">Mobile</label>
                                <InputText value={mobile} id="mobile" onChange={(e) => setMobile(e.target.value)} className="p-inputtext-sm" />
                                {mobileError && <small className="p-error">Please enter a valid UK phone number.</small>}
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 fitter-feild">
                                <label htmlFor="position">Position</label>
                                <InputText value={position} id="position" onChange={(e) => setPosition(e.target.value)} className="p-inputtext-sm" />
                                {positionError && <small className="p-error">This field is required</small>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="depot">Depot</label>
                                    <Dropdown value={depot} onChange={(e) => setDepot(e.value)} options={depots} optionLabel="depot"
                                        placeholder="Select Depot" className="w-full md:w-14rem" />
                                    {depotError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>
                        </div>

                        <div className="col-12 padr-20">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="userName">User Name</label>
                                    <InputText value={userName} id="userName" onChange={(e) => setUserName(e.target.value)} className="p-inputtext-sm" />
                                    {userNameError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>

                            <div>
                                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                    <div className="flex flex-column gap-2 fitter-feild">
                                        <label htmlFor="password">Password</label>
                                        <input type="password" className="form-control mrb-10" id="password" name="password" value={password} onChange={(e) => setPassword(e.target.value.trim())} />
                                        {isAddUser && passwordError && <small className="p-error">This field is required</small>}
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                    <div className="flex flex-column gap-2 fitter-feild">
                                        <label htmlFor="confirmPassword">Confirm Password</label>
                                        <input type="password" className="form-control mrb-10" id="confirmPassword" name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value.trim())} />
                                        {confirmPasswordError && <small className="p-error">This field is required</small>}
                                        {passwordMismatchError && <small className="p-error">Password & Confirm Password are not same </small>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <div className="flex flex-column gap-2">
                                <label htmlFor="eco" className="padr-5">Eco</label>
                                <Checkbox value={eco} id="eco" onChange={e => setEco(e.checked)} checked={eco}></Checkbox>
                            </div>
                        </div>

                        <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                            <div className="flex flex-column gap-2">
                                <label htmlFor="newBuild" className="padr-5">NewBuild</label>
                                <Checkbox value={newBuild} id="newBuild" onChange={e => setNewBuild(e.checked)} checked={newBuild}></Checkbox>
                            </div>
                        </div>

                        <div className="row padr-20  pad-tb-20">
                            <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 pad-tb-20">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="maxAppWebAccess" className="padr-5">MaxAppWebAccess</label>
                                    <Checkbox value={maxAppWebAccess} id="maxAppWebAccess" onChange={e => setMaxAppWebAccess(e.checked)} checked={maxAppWebAccess}></Checkbox>
                                </div>
                            </div>

                            <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 pad-tb-20">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="isFinanceTeam" className="padr-5">IsFinanceTeam</label>
                                    <Checkbox value={isFinanceTeam} id="isFinanceTeam" onChange={e => setIsFinanceTeam(e.checked)} checked={isFinanceTeam}></Checkbox>
                                </div>
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="isActive" className="padr-5">IsActive</label>
                                    <Checkbox value={isActive} id="isActive" onChange={e => setIsActive(e.checked)} checked={isActive}></Checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        </Fragment>
    )
}

export default Users;